module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0022_D18_Final.5ca9884.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0022_D18_Final.jpg
// module id = Yep7
// module chunks = 0